'use strict';

/* global angular */

const _ = require('lodash');

/** @ManagerStore */
const ManagerStore = function (APP_DISPATCHER_ID, Flux, IdentityService, ManagerActions, ManagerService, MetricsService, ResourceHelper) {

  const ORG_PROCESSING_PUBNUB_PUBKEY = IdentityService.get('pubnub.processingJobs');
  //Store init
  const ManagerStore = Flux.Store.create({
    name: 'ManagerStore',
    events: {
      Created: true,
      Changed: true,
      Delayed: true,
      Updated: true,
      OpenDialog: true,
      OpenDetailView: true,
      CloseDetailView: true,
      ProcessingJobDestroyed: true,
      DeletedProject: true
    }
  });

  //Null initial state
  ManagerStore.$state = {
    projects: null,
    jobs: [],
    job: null
  };

  const SiteStore = Flux.Store.get('SiteStore');

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  ManagerStore.init = function () {

    const d = Flux.Dispatcher.get(APP_DISPATCHER_ID);
    d.register(ManagerActions.Changed, this._handleJobsChanged.bind(this));
    d.register(ManagerActions.OpenDialog, this._handleOpenDialog.bind(this));
    d.register(ManagerActions.CloseDetailView, this._handleCloseDetailView.bind(this));
    d.register(ManagerActions.OpenDetailView, this._handleOpenDetailView.bind(this));
    d.register(ManagerActions.DeleteDataSet, this._handleDeleteDataset.bind(this));
  };

  ManagerStore.setState = (state) => {

    angular.extend(ManagerStore.$state, state);
  };


  ManagerStore.loadProjects = (bypassCache) => {

    const OrganizationProjectsResource = ResourceHelper.getResource('OrganizationProject');
    const request = {
      organizationId: IdentityService.get('currentOrganization').id,
      bypassCache: !!bypassCache || !ManagerStore.get('projects')
    };
    const params = {
      include: 'sites.dataCaptures.processingJob.dataFiles'
    };
    return OrganizationProjectsResource.findAll(params, request)
    .then((projects) => {

      MetricsService.track('datasetManagerReady', 'datasetManagerDataReady');
      ManagerStore.$set('projects', projects);
      return projects;
    });
  };

  ManagerStore.fetchJobDetail = (jobUuid) => {

    const ProcessingJobResource = ResourceHelper.getResource('ProcessingJob');
    if (!ManagerStore.getJob(jobUuid)) {

      return ProcessingJobResource.find(jobUuid, {
        params: { include: 'userName,dataset,dataFiles,dataCapture.dataCaptureLayers,site.project' },
        bypassCache: false
      })
      .then((res) => {

        let job = res;
        if (job.dataset) {
          job.dataset.meta = JSON.parse(job.dataset.meta);
          if (job.dataset.meta) {
            job.dataset.meta.points = job.dataset.meta.points && job.dataset.meta.points.map((point) => {

              return _decorateCoordinate('photo', point);
            })
            .filter((point) => { return point; });
            if (job.dataset.meta.gcpCount > 0) {
              job.dataset.meta.gcps = job.dataset.meta.gcps && job.dataset.meta.gcps.map((gcp) => {

                return _decorateCoordinate('gcp', gcp);
              })
              .filter((point) => { return point; });
            }
            job.dataset.meta.antenna = job.dataset.meta.antenna && _decorateCoordinate('base', job.dataset.meta.antenna, 1);
            job.dataset.meta.flightDate = ManagerService.makeNiceDate(job.dataset.meta.flightDate);
          }
        }
        const layers = job.dataCapture.dataCaptureLayers;
        for (let layer of layers) {
          switch (layer.layerType) {
          case 'tileLayer':
            layers.layerTypeClean = layers.layerTypeString + ' Map';
            break;
          case 'pc_rgb':
            layers.layerTypeClean = layers.layerTypeString;
            break;
          case 'mesh_gltf':
            layers.layerTypeClean = layers.layerTypeString;
            break;
          }
        }

        const project = ManagerStore.get('projects')[job.site.project.id];
        if (project && project.parsedJob) {
          job = _.merge(job, project.parsedJob);
        }
        else {
          job = ManagerService.makeNiceJobData(job, job.site, job.dataCapture);
        }

        ManagerStore.setJob(job);
        ManagerStore.$set('job', job);
        return job;
      });
    }
    else {
      ManagerStore.$set('job', ManagerStore.getJob(jobUuid).value);
      return ManagerStore.getJob(jobUuid).value;
    }
  };

  ManagerStore.getJob = (uuid) => {

    return _.find(ManagerStore.get('jobs'), (job) => {

      return job.key === uuid;
    });
  };

  ManagerStore.setJob = (job) => {

    const jobs = ManagerStore.get('jobs');
    jobs.push({
      key: job.uuid.toString(),
      value: _.clone(job)
    });
    ManagerStore.setState({
      jobs: _.clone(jobs)
    });
  };

  ManagerStore.syncSubscribe = () => { // subscribe to all events by ORGANIZATION

    const SyncStore = Flux.Store.get('SyncStore');
    const orgKey = `orgProcessing-${IdentityService.get('currentOrganization').id}`;
    SyncStore.subscribe(ORG_PROCESSING_PUBNUB_PUBKEY, orgKey, {
      message: (msg) => {
        switch (msg.status) {
        case 0:
          ManagerStore._handleJobsChanged(msg.id)
          .then((changedModels) => {

            ManagerStore.emit(ManagerStore.Events.Created, changedModels);
          });
          break;
        case -1:
          ManagerStore._handleJobsChanged(msg.id)
          .then((changedModels) => {

            // ManagerStore.emit(ManagerStore.Events.Delayed, changedModels); // TODO: Define flow for delayed jobs
            ManagerStore.emit(ManagerStore.Events.Created, changedModels);
          });
          break;
        default:
          ManagerStore._handleJobsChanged(msg.id)
          .then((changedModels) => {

            ManagerStore.emit(ManagerStore.Events.Changed, changedModels);
          });
          break;
        }
      }
    });
  };

  // Handlers //////////////////////////////////////////////////////////////////

  ManagerStore._handleJobsChanged = (jobId) => {

    // This will respond to a pubnub event and replace the job in the
    // controller/cache when a job has updated
    return ManagerStore.loadProjects(true)
    .then((projects) => {

      // Find the project that contains this organization. If it exists, reformat
      let job;
      let project = _.find(projects, (x) => {

        return _.find(x.sites, (s) => {

          let dc =  _.find(s.dataCaptures, 'processingJobId', jobId);
          if (dc) {
            job = dc.processingJob;
          }
          return dc;
        });
      });
      return {
        job, project
      };
    });
  };

  ManagerStore._handleCloseDetailView = () => {

    ManagerStore.emit(ManagerStore.Events.CloseDetailView);
  };

  ManagerStore._handleOpenDetailView = () => {

    ManagerStore.emit(ManagerStore.Events.OpenDetailView);
  };

  ManagerStore._handleOpenDialog = (payload) => {

    ManagerStore.$set('view', payload.view);

    if (payload.data) {
      if (payload.data.user) {
        ManagerStore.$set('user', payload.data.user);
      }
      if (payload.data.plan) {
        ManagerStore.$set('plan', payload.data.plan);
      }
      if (payload.data.message) {
        ManagerStore.$set('message', payload.data.message);
      }
      if (payload.data.action) {
        ManagerStore.$set('action', payload.data.action);
      }
    }

    ManagerStore.emit(ManagerStore.Events.OpenDialog);
  };

  ManagerStore._handleDeleteDataset = () => {

    const ProcessingJobResource = ResourceHelper.getResource('ProcessingJob');
    const job = ManagerStore.get('job');
    return ProcessingJobResource.destroy(job, {
      params: {
        siteId: job.site.id
      }
    })
    .then(() => {

      ManagerStore.$set('job', null);
      ManagerStore.loadProjects(true)
      .then(() => {

        ManagerStore.emit(ManagerStore.Events.ProcessingJobDestroyed);
      });
    });
  };

  ManagerStore.clearStore = () => {

    ManagerStore.$set('projects', null);
    ManagerStore.$set('jobs', []);
    ManagerStore.$set('job', null);
  };

  /**
   * Wraps a coordinate in a geoJSON object
   * This is necessary to make smaller both the request payload w.r.t
   * to storing the photo coordinate geoJSON points, and also reduce the
   * size of the meta string in the data_sets table
   *
   * TODO store the photo name for potential lookup capabilities
   */
  const _decorateCoordinate = (type, point, id) => {

    if (point[0] && point[1]) {
      return {
        type,
        id: id || '', // not saved
        data: {
          type: 'Feature',
          properties: {
            name: id || '', // not saved
            latitude: point[1],
            longitude: point[0]
          },
          geometry: {
            type: 'Point',
            coordinates: point
          }
        },
        properties: { }
      };
    }
    return null;
  };

  // Store Handlers //////////////////////////////////////////////////////////////////

  this._handleSiteUpdated = (site) => {

    const projects = ManagerStore.get('projects');
    const project = _.find(projects, { id: site.projectId });

    if (!project) {
      return;
    }

    if (site.name) {
      project.name = site.name;
    }

    project.sites[0] = site;

    ManagerStore.setState({ projects });
  };

  this._handleSiteDeleted = (site) => {

    let projects = ManagerStore.get('projects');
    const OrganizationProjectsResource = ResourceHelper.getResource('OrganizationProject');
    const projectToDelete = _.find(projects, 'id', site.projectId);

    if (projectToDelete) {
      projects = _.reject(projects, { 'id': projectToDelete.id });

      OrganizationProjectsResource.eject(projectToDelete);
      ManagerStore.setState({ projects });
      ManagerStore.emit(ManagerStore.Events.DeletedProject, projectToDelete);
    }
  };

  // Store Bindings
  SiteStore.on(SiteStore.Events.ChangedWithUpdatedSite, this._handleSiteUpdated.bind(this));
  SiteStore.on(SiteStore.Events.ChangedWithDeletedSite, this._handleSiteDeleted.bind(this));

  return ManagerStore;
};

ManagerStore.$inject = ['APP_DISPATCHER_ID', 'sbFlux', 'IdentityService', 'ManagerActions', 'ManagerService', 'MetricsService', 'ResourceHelper'];

module.exports = ManagerStore;



// WEBPACK FOOTER //
// ./src/app/manager/dataStores/ManagerStore.js